<div class="item-label">
  <ng-content></ng-content>
</div>
